import { render, staticRenderFns } from "./NoPermissionSection.vue?vue&type=template&id=dffe96c6&scoped=true&"
import script from "./NoPermissionSection.vue?vue&type=script&lang=js&"
export * from "./NoPermissionSection.vue?vue&type=script&lang=js&"
import style0 from "./NoPermissionSection.vue?vue&type=style&index=0&id=dffe96c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffe96c6",
  null
  
)

export default component.exports